import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import Tours from "../pages/Tours";
import Services from '../components/Services/services.jsx'
import TourDetails from "../pages/TourDetails";
import Login from "../pages/Login";
import Register from "../pages/Register";
import About from "../pages/About";
import SearchResultList from "../pages/SearchResultList";
import ThankYou from "../pages/ThankYou";
import Contact from "../pages/Contact.jsx";
import Webmail from "../pages/Webmail.jsx";
import Booking from "../pages/Booking.jsx";
import Events from "../pages/Events.jsx";

const Routers = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<Navigate to="/" />} /> */}
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/tours" element={<Tours />} />
      <Route path="/services" element={<Services />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/events" element={<Events />} />
      <Route path="/tours/:id" element={<TourDetails />} />
      <Route path="/login" element={<Login />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/register" element={<Register />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/tour/search" element={<SearchResultList />} />
      <Route path="/webmail" element={<Webmail />} />
    </Routes>
  );
};

export default Routers;
